import { LogoutIcon } from '@spark-web/icon';
import { FC } from 'react';

import { User } from '~/types/user';
import { getEnterprisePartnerName } from '~/utils/enterprise-partner';

import ProfilePill from '../components/profile-pill';

type UserProfileProps = {
  user: Pick<User, 'name' | 'picture' | 'enterprisePartnerId'>;
};

export const UserProfile: FC<UserProfileProps> = ({ user }) => {
  const { enterprisePartnerId, name, picture } = user || {};

  if (!name || !picture) {
    return null;
  }

  return (
    <ProfilePill
      name={name}
      organization={getEnterprisePartnerName(enterprisePartnerId)}
      picture={picture}
      menuLinks={[
        {
          href: 'auth/logout',
          text: 'Log out',
          icon: <LogoutIcon size="xsmall" />,
        },
      ]}
    />
  );
};

export default UserProfile;
